export default __webpack_public_path__ + "static/media/mediamanager.27e87b57.jpg";